import type { ReactNode } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

interface LegalLayoutProps {
  title: string;
  lastUpdated?: string;
  children: ReactNode;
}

export default function LegalLayout({ title, lastUpdated, children }: LegalLayoutProps) {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <div className="max-w-[800px] mx-auto px-4 md:px-6 py-16 md:py-24">
        <h1 className="text-2xl md:text-[32px] font-display font-bold text-foreground-950 leading-tight">
          {title}
        </h1>
        {lastUpdated && (
          <p className="mt-3 text-sm text-foreground-600">
            Редакция от {lastUpdated}
          </p>
        )}
        <div className="mt-10 md:mt-14 text-foreground-800 leading-relaxed space-y-10 text-[15px] md:text-[16px]">
          {children}
        </div>
      </div>
      <Footer />
    </div>
  );
}